module.exports = __webpack_public_path__ + "static/media/Info.ecaef146.svg";